import React, { useState } from "react";
import ConfigForm from "./components/ConfigForm";
import Report from "./components/Report";
import { simulate } from "./api";
import { SimulateRequest, SimulationSummaryResponse } from "./types";
import Footer from "./components/Footer";

const App: React.FC = () => {
  const [data, setData] = useState<SimulationSummaryResponse | null>(null);
  const [isRunning, setIsRunning] = useState(false);
  const [error, setError] = useState<string>("");

  async function handleSubmit(form: SimulateRequest) {
    setIsRunning(true);
    setError("");
    try {
      const resp = await simulate(form);
      setData(resp);
    } catch (e: any) {
      setError(e?.message ?? "Unknown error");
    } finally {
      setIsRunning(false);
    }
  }

  return (
    <div className="container d-flex flex-column gap-1">
      <h1>Fire Simulator</h1>

      <ConfigForm onSubmit={handleSubmit} />

      {error && <div className="alert alert-danger mt-3">{error}</div>}

      {data && (
        <div className="position-relative mt-2">
          {/* prevent interaction while recalculating */}
          <div className={isRunning ? "pe-none" : ""}>
            <Report data={data} />
          </div>

          {isRunning && (
            <div
              className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-start align-items-center"
              style={{ background: "rgba(255,255,255,0.7)", backdropFilter: "blur(2px)", paddingTop: "0.75rem" }}
              aria-live="polite"
            >
              <div className="d-flex align-items-center">
                <div className="spinner-border spinner-border-sm me-2 p-2" role="status" aria-label="Recalculating…" />
                <span className="text-muted small">Recalculating… previous results shown</span>
              </div>
            </div>
          )}

        </div>
      )}

      <Footer />
    </div>
  );
};

export default App;
